import { Component, Input, OnInit } from '@angular/core';
import { convertMinutes } from '@app/utils/functions/srIrops';
/**
 * Componente que muestra el itinerario de revisión de IROP.
 * 
 * Este componente recibe información sobre los segmentos de vuelo y muestra
 * detalles como la duración total del vuelo, el número de vuelo y si es un vuelo directo o con escalas.
 */
@Component({
    selector: 'irop-review-itinerary',
    templateUrl: './irop-review-itinerary.component.html',
    styleUrls: ['./irop-review-itinerary.component.scss'],
    standalone: false
})
export class IropReviewItineraryComponent implements OnInit {

 /** Información del tramo de vuelo */
 @Input() leg: any;
  
 /** Tipo de intercambio, por defecto es 'OUTBOUND' */
 @Input() exchangeType: string = 'outbound';
 
 /** Tipo de vuelo */
 @Input() type: any;

 /** determina si tiene paradas el segemento */
 @Input() isNonStopProp: boolean = false

 /** Estado de colapso del componente */
 isCollapsed: boolean = false;
 
 /** Segmentos del vuelo */
 segments: any;
 
 /** Primer segmento del vuelo */
 flightSegment: any;
 
 /** Fecha y hora de salida */
 departing: any;
 
 /** Indica si el vuelo es directo */
 isNonStop: boolean;
 
 /** Número del vuelo */
 flightNumber: string;
 
 /** Cantidad de conexiones en el vuelo */
 connecting: number;
 
 /** Duración total del vuelo en formato legible */
 totalTime: string;
 
 /** Índice del segmento de vuelo basado en exchangeType */
 segNumber: number;

  constructor(
  ) { }

  ngOnInit() {
    this.segNumber = this.exchangeType == 'outbound' ? 0 : 1;
    this.segments = this.leg?.segments;

    this.departing = this.segments[this.segNumber]?.departureDateTime;
    this.isNonStop = this.nonStop;
    this.flightNumber = this.fNumber;
    this.connecting = this.segments?.length - 1;
    this.totalTime = this.calcTotalTimeFlying;
  }
  /**
   * Determina si el vuelo es directo o con escalas
   */
  get nonStop() {
    return this.isNonStopProp;
  }

  /**
   * Obtiene el número de vuelo combinando el operador y código de vuelo
   */
  get fNumber() {
    return this.segments.map((seg) => {
      const operatingCarrier = seg?.marketingCarrier;
      const operatingFlightCode = seg?.operatingFlightCode;

      return `${operatingCarrier} ${operatingFlightCode}`;
    }).join(', ');
  }
 /**
   * Calcula el tiempo total de vuelo sumando la duración de cada segmento
   */
  get calcTotalTimeFlying() {

    return convertMinutes(this.leg?.totalFlightTimeInMinutes);
  }
 /**
   * Alterna el estado de colapso del componente
   */
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
}
